import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Comment utiliser les produits pour obtenir les meilleurs résultats ?',
      answer: 'Pour des résultats optimaux, nous recommandons d\'utiliser nos produits matin et soir sur une peau propre et sèche. Commencez par notre exfoliant 2 à 3 fois par semaine, puis appliquez le sérum hydratant suivi de votre crème. La régularité est la clé pour voir des résultats visibles en 2 à 4 semaines.'
    },
    {
      question: 'Les produits conviennent-ils à tous les types de peau ?',
      answer: 'Oui, nos formules sont conçues pour convenir à tous les types de peau, y compris les peaux sensibles. Tous nos produits sont testés dermatologiquement et hypoallergéniques. Si vous avez des préoccupations spécifiques, n\'hésitez pas à contacter notre équipe d\'experts pour des recommandations personnalisées.'
    },
    {
      question: 'Combien de temps faut-il pour voir des résultats ?',
      answer: 'La plupart de nos clientes constatent une amélioration visible de leur peau dès la première application, avec un éclat immédiat et une texture plus douce. Pour des résultats durables et une transformation complète, nous recommandons une utilisation régulière pendant 4 à 6 semaines.'
    },
    {
      question: 'Puis-je utiliser vos produits pendant la grossesse ?',
      answer: 'Nos produits sont formulés avec des ingrédients naturels et sûrs. Cependant, nous recommandons toujours de consulter votre médecin ou dermatologue avant d\'utiliser de nouveaux produits de soin pendant la grossesse ou l\'allaitement, car chaque situation est unique.'
    },
    {
      question: 'Les produits sont-ils testés sur les animaux ?',
      answer: 'Absolument pas. Nous sommes fiers d\'être une marque 100% cruelty-free. Aucun de nos produits ni ingrédients n\'est testé sur les animaux. Nous sommes certifiés par plusieurs organisations de protection animale et nous nous engageons à maintenir cette éthique.'
    },
    {
      question: 'Les soins à l\'ADN de saumon conviennent-ils aux personnes allergiques ?',
      answer: 'Les produits contenant du PDRN (ADN de saumon) sont généralement bien tolérés. Toutefois, par mesure de précaution, ils sont déconseillés aux personnes présentant une allergie connue au poisson ou aux produits d\'origine marine. Nous recommandons toujours d\'effectuer un test cutané avant la première utilisation.'
    },
    {
      question: 'Proposez-vous des consultations personnalisées ?',
      answer: 'Oui ! Notre équipe d\'esthéticiennes diplômées est disponible pour des consultations gratuites. Vous pouvez nous contacter par téléphone, email ou prendre rendez-vous dans notre institut pour une analyse de peau personnalisée et des recommandations adaptées à vos besoins spécifiques.'
    },
    {
      question: 'Quels sont les délais de livraison ?',
      answer: 'Votre colis est préparé avec soin dans les 24 à 48h ouvrées suivant votre commande. La livraison est ensuite prévue entre 5 et 8 jours ouvrés. Vous recevrez un email de confirmation avec le numéro de suivi dès l\'expédition de votre commande.'
    }
  ];

  return (
    <section className="py-20 bg-[#FAF9F7]">
      <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
        {/* Titre section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-4">
            FAQ
          </h2>
          <p className="text-lg text-gray-600">
            Les réponses à vos questions les plus fréquentes
          </p>
        </div>

        {/* Liste FAQ */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer group"
              >
                <span className="text-base font-semibold text-gray-900 pr-8 group-hover:text-[#E8B4A8] transition-colors">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-gray-400 group-hover:text-[#E8B4A8] transition-all duration-300`}></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA contact */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">Une autre question ?</p>
          <a 
            href="/#contact"
            className="inline-block px-8 py-3 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Contactez-nous
          </a>
        </div>
      </div>
    </section>
  );
}
